/**
 * Checks if the given string is a valid email format.
 * @param {string} email
 * @returns {boolean}
 */
function isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

function isValidPhone(phone) {
    const re = /^\+?[1-9]\d{1,14}$/; // E.164 format
    return re.test(phone);
}

function isValidLicensePlate(plate) {
    // EU format: 1-3 letters, optional space or dash, 1-4 numbers
    // Estonian format: 1-4 numbers, optional space or dash, 1-3 letters
    const re = /^([A-Z]{1,3}[-\s]?[0-9]{1,4}|[0-9]{1,4}[-\s]?[A-Z]{1,3})$/;
    return re.test(plate);
}

function isValidName(name) {
    const re = /^[a-zA-Z\säöüÄÖÜß]+$/;
    return re.test(name.trim());
}

export { isValidEmail, isValidPhone, isValidLicensePlate, isValidName };
